const chaUserPassword = 'pando@123';

const chaUserStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
};

module.exports = {
  chaUserPassword,
  chaUserStatus,
};
